'use strict';

var murmurhashJs = require('murmurhash-js');

/**
 * This is a reimplementation of https://www.npmjs.com/package/hash-index, using a pure JS
 *   implementation of murmur3 for hashing instead of Node's crypto APIs, making it suitable
 *   for use in a browser environment.
 */
function hashIndex(input, maximum = Infinity) {
    return murmurhashJs.murmur3(input) % maximum;
}

module.exports = hashIndex;
//# sourceMappingURL=index.js.map
